module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic2.fcbf93f2.png";